import { createFileRoute, redirect } from '@tanstack/react-router';

// Parent Incoming folded into the chain pipeline board; keep the path alive as a redirect.
export const Route = createFileRoute('/_authenticated/_app/crm/chain/parent-incoming')({
	beforeLoad: () => {
		throw redirect({ to: '/crm/chain/pipeline' });
	},
});
